import { createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { ExchangeStatus, ExchangeStatusStream } from '@/types/generated/public_api'

export const useExchangeStatusStream = createStreamHook<ExchangeStatusStream, ExchangeStatus>({
  channelKey: 'exchangeStatusStream',
  // Every subscriber shares the flat 'exchangeStatusStream' listener key, so
  // each one sees EVERY venue's push. Without this guard a Deribit hook would
  // write Hyperliquid's status into Deribit's cache entry (and vice versa) and
  // both rows would show whichever beacon fired last. Same guard the venue
  // health stream applies for the same reason.
  extractResponse: (message, payload) => {
    const status = message.data?.exchangeStatus
    return status?.exchange === payload.exchange ? status : undefined
  },
  getPayloadDeps: (p) => [p.exchange],
  listenerChannelKey: 'exchangeStatusStream',
})
